export default {
    appTitle: 'Web Mobile - Compostière du Gros-de-Vaud Sàrl',
    imagesProxyUrl: 'https://imagesproxy.mimatech.ch'
}